import { Icon } from 'components/Icon'
import { Spinner } from 'components/Spinner'
import { round } from 'utils'
import React from 'react'
import styled, { css } from 'styled-components'

export const shieldStyles = css`
	height: 100%;
	position: relative;

	.percentage {
		position: absolute;
		top: 45%;
		left: 50%;
		transform: translate(-50%, -50%);
		font-family: 'Roboto Condensed', inherit;
	}

	.icon {
		height: 100%;
		width: auto;
		color: ${props => props.theme.colors.secondary.val};
		display: block;

		svg {
			height: 100%;
			min-height: 80px;
			width: auto;
		}
	}

	.percentage {
		color: ${props => props.theme.colors.secondary.val};
		font-size: 24px;
		letter-spacing: -1px;
		font-weight: 700;
	}

	.spinner {
		span {
			width: 24px;
			height: 24px;
		}
	}

	&.__small {
		.percentage {
			font-size: 15px;
		}

		.icon {
			svg {
				min-height: 46px;
				max-height: 46px;
			}
		}

		.spinner {
			span {
				width: 13px;
				height: 13px;
			}
		}
	}
`

const ShieldView = styled.div`
	${shieldStyles}
`

type ShieldProps = {
	className?: string
	isSmall?: boolean
	value: number | null
	isLoading?: boolean
}

export const Shield = ({ className, isSmall, value, isLoading }: ShieldProps) => {
	const percentage = typeof value === 'number' ? round(value > 1 ? value : value * 100) : 0

	const isStar = value === 1

	return (
		<ShieldView
			className={`shield${className ? ` ${className}` : ''}
      ${isSmall ? ' __small' : ''}`}
		>
			<Icon type={isStar ? 'shieldStar' : 'shieldOutline'} />
			{isLoading ? (
				<Spinner type='circle' height='sm' noBg />
			) : typeof value === 'number' && !isStar ? (
				value ? (
					<div className='percentage'>{percentage}%</div>
				) : null
			) : null}
		</ShieldView>
	)
}
